import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdTextField} from "../../core/components/fields/fields";
import {BlockComp} from "../../core/components/blockComp/blockComp";
import ActiveItem from "../../core/components/blockComp/activeItem";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {ProjectVersion} from "../domain/project/projectVersionDomain";

@observer
class ProjectVersionForm extends React.Component<FormProps<ProjectVersion, ProjectVersion>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {version, description, firstComment, secondComment, thirdComment, fourthComment} = fields;

    let openContent = (
      <div>
        <div className="row">
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...version.props} />
            <Validate field={version} value={version.props.value}/>
          </div>
          <div className='fx col-xs-10 col-sm-10'>
            <MdTextField {...description.props}/>
          </div>
          </div>

        <div className="row">
          <div className='fx col-xs-3 col-sm-3'>
          <MdTextField {...firstComment.props} />
          <Validate field={firstComment} value={firstComment.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...secondComment.props} />
            <Validate field={secondComment} value={secondComment.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...thirdComment.props} />
            <Validate field={thirdComment} value={thirdComment.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...fourthComment.props} />
            <Validate field={fourthComment} value={fourthComment.props.value}/>
          </div>

        </div>

      </div>
    );

    return (
      <BlockComp noPadding style={{margin: 0}}>
        <ActiveItem closedStyle={{padding: "0 10px"}} openContent={openContent}
                    closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />}
                    validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersion>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} style={{display: "flex", flexDirection:"column"}} >
      <ClosedFormField label={fields.version.textLabel} value={dataObject.version}/>
      <ClosedFormField label={fields.description.textLabel} value={dataObject.description}/>
    </ClosedFormBlock>
  </div>
);


const definition: DefinitionType = {
  formName: 'ProjectVersionForm',
  fields: [
    {
      name: 'version',
      validators: ['IsRequired', {validation: 'HasLength', parameters: {min: 1, max: 5}}, 'IsNumber']
    },
    {
      name: 'description',
    },
    {
      name: 'firstComment',
      validators: [{validation: 'HasLength', parameters: {min: 1, max: 35}}]
    },
    {
      name: 'secondComment',
      validators: [{validation: 'HasLength', parameters: {min: 1, max: 35}}]
    },
    {
      name: 'thirdComment',
      validators: [{validation: 'HasLength', parameters: {min: 1, max: 35}}]
    },
    {
      name: 'fourthComment',
      validators: [{validation: 'HasLength', parameters: {min: 1, max: 35}}]
    },

  ]
};

export default createForm(definition, ClosedContent)(ProjectVersionForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionForm.tsx